module.exports = __webpack_public_path__ + "img/Z60_07.615e6c80.jpg";